import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../utils/components/ui/dialog";
import { Button } from "../../utils/components/ui/button";
import Loading from "../common/LoaderCommon";
import { useGetPaymentSlip } from "../../service/customerService";
import { toast } from "react-toastify";

interface SlipModalProps {
  open: boolean;
  onCancel: () => void;
  onClose?: () => void;
  transactions: { id: string; name: string; date: string }[];
  loading?: boolean;
}

export const SlipModal: React.FC<SlipModalProps> = ({
  open,
  onCancel,
  onClose,
  transactions,
}) => {
  console.log(transactions, "transactions");
  const [selectedTransactionId, setSelectedTransactionId] = useState("");
  const PrintPaymentSlip = useGetPaymentSlip({
    onSuccess: (data: string) => {
      // toast.success('Invoice printed successfully');
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(data);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        setSelectedTransactionId("");
        if (onClose) onClose();
      } else {
        toast.error("Popup blocked! Please allow popups for this site.");
        setSelectedTransactionId("");

        if (onClose) onClose();
      }
    },
    onError: (error: Error) => {
      toast.error(`Error printing payment slip: ${error.message}`);
    },
  });

  const handlePrint = () => {
    if (selectedTransactionId) {
      PrintPaymentSlip.mutate({ id: selectedTransactionId });
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen && onClose) onClose();
      }}
    >
      <DialogContent className="max-w-md w-full">
        {PrintPaymentSlip?.isPending ? (
          <Loading />
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="text-[#1A5EF9] text-2xl font-bold mb-4">
                Print Slip
              </DialogTitle>

              {/* Native HTML Select */}
              <select
                value={selectedTransactionId}
                onChange={(e) => setSelectedTransactionId(e.target.value)}
                className="w-full border border-gray-300 rounded-md p-2"
              >
                <option value="">Select Transaction Date</option>
                {transactions?.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.date}
                  </option>
                ))}
              </select>
            </DialogHeader>

            <DialogFooter className="flex flex-row gap-4 mt-6">
              <Button
                type="button"
                variant="outline"
                className="w-1/2 text-lg font-semibold"
                onClick={onCancel}
              >
                Cancel
              </Button>
              <Button
                onClick={handlePrint}
                className="w-1/2 bg-[#1A5EF9] text-white text-lg font-semibold hover:bg-[#7bb11c]"
                disabled={!selectedTransactionId || PrintPaymentSlip?.isPending}
              >
                Print
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SlipModal;
